import { RPCDocs } from "../../../../../services/rpc.js";
import { FormikSelect } from "../../../../../components/FormikFields/FormikSelect.js";
import { FormikSelectRecordTag } from "../../FormikSelectRecordTag.js";
import { useRecordsFieldOptionsConfig } from "../../../../RecordsFieldOptionsConfig/context.js";
import { toOptions } from "../../../../RecordsFieldOptionsConfig/utils.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
//#region src/modules/Records/shared/RecordSearchFilters/components/ItemFields.tsx
function ItemFields() {
	const { values } = useFormikContext();
	const config = useRecordsFieldOptionsConfig();
	return /* @__PURE__ */ jsx("div", {
		className: "flex w-full flex-col",
		children: values.config.showAdvancedFilters && /* @__PURE__ */ jsxs("div", {
			className: "gap-xxs grid grid-cols-3 md:grid-cols-3",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2 md:col-span-1",
					children: /* @__PURE__ */ jsx(FormikSelectRecordTag, {
						combineSelected: true,
						isClearable: true,
						multi: true,
						name: "item.tags",
						placeholder: "Tags",
						returnValueMode: "value",
						typeFilter: [RPCDocs.Records.GetRecordTagsList.v1.TypeFilter.Item]
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-1",
					children: /* @__PURE__ */ jsx(FormikSelect, {
						allowCreate: true,
						isClearable: true,
						name: "item.color",
						options: toOptions(config?.item.color),
						placeholder: "Colors"
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2 md:col-span-1",
					children: /* @__PURE__ */ jsx(FormikSelect, {
						allowCreate: true,
						isClearable: true,
						name: "item.status",
						options: toOptions(config?.item.status),
						placeholder: "Status"
					})
				})
			]
		})
	});
}
//#endregion
export { ItemFields };

//# sourceMappingURL=ItemFields.js.map